module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./ReplaceGoodsView.js"));
	}, "ReplaceGoodsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ReplaceGoodsView!./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ReplaceGoods/ReplaceGoodsView.js
// module id = 1061
// module chunks = 431